module.exports = __webpack_public_path__ + "img/preparing.9f8cc628.svg";